export function throwError(originalError, cb) {
    if (originalError instanceof Error) {
        throw cb(originalError);
    }
    else {
        throw originalError;
    }
}
